import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

type NbStatus =
  | 'primary'
  | 'success'
  | 'info'
  | 'warning'
  | 'danger'
  | 'basic';

interface StatusIconState {
  icon: string;
  nbStatus: NbStatus;
  label: string;
  spinning?: boolean;
}

@Component({
  selector: 'app-status-icon',
  templateUrl: './status-icon.component.html',
  styleUrl: './status-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StatusIconComponent {
  @Input() status: string | null = null;

  private readonly defaultState: StatusIconState = {
    icon: 'minus-outline',
    nbStatus: 'basic',
    label: 'Unknown',
    spinning: false,
  };

  private readonly stateMap: Record<string, Partial<StatusIconState>> = {
    ACTIVE: {
      icon: 'checkmark-circle-2-outline',
      nbStatus: 'success',
      label: 'Active',
    },
    QUEUED: {
      icon: 'sync-outline',
      nbStatus: 'info',
      label: 'Queued',
      spinning: true,
    },
    ERROR: {
      icon: 'alert-circle-outline',
      nbStatus: 'danger',
      label: 'Error',
    },
  };

  get state(): StatusIconState {
    const normalized = (this.status ?? '').toUpperCase();
    const label = this.formatLabel(this.status);
    const match = this.stateMap[normalized] ?? {};

    return {
      ...this.defaultState,
      ...match,
      label: match.label ?? label,
    };
  }

  private formatLabel(value: string | null): string {
    if (!value) {
      return 'Unknown';
    }

    return value[0].toUpperCase() + value.slice(1).toLowerCase();
  }
}
